import { render, staticRenderFns } from "./ListCommentItem.vue?vue&type=template&id=70e8642e&"
import script from "./ListCommentItem.vue?vue&type=script&lang=js&"
export * from "./ListCommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports